// Central content for Hotel Virasat Retreat, Patna
// NOTE: Contact details are placeholders — update with real numbers/email.

export const HOTEL = {
  name: "Hotel Virasat Retreat",
  tagline: "Traditional Hospitality, Modern Facilities",
  zomato: "https://zomato.onelink.me/xqzv/sqxfnajw",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Hotel+Virasat+Retreat+Medanta+Patna",
  facebook: "https://www.facebook.com/share/1S5rP7CySv/",
  instagram: "https://www.instagram.com/hotelvirasatretreat3?utm_source=qr&igsh=MzBkYTJscXVtZ2Nk",
  menuUrl: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/mxrrvfeo_menu-3%284%29.pdf",
  firezzaMenuUrl: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/hn1dm807_Fire%20n%20Fury%20Menu%20A4%20%282%29.pdf",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/ulr8tz3n_IMG-20260803-WA0007.jpg",
  phone: "+917765090955",
  phoneDisplay: "+91 77650 90955",
  whatsapp: "917765090955",
  email: "hotelvirasatretreat@gmail.com",
  addressLine: "Opposite Medanta Super Speciality Hospital, Kankarbagh",
  city: "Patna",
  state: "Bihar",
  pincode: "800020",
  mapQuery: "Medanta+Hospital+Patna",
  rooms: 16,
  checkIn: "12:00 PM",
  checkOut: "11:00 AM",
};

export const RESTAURANT_STRIP = [
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/fgj3oynb_IMG-20251208-WA0080.webp", alt: "ROOFTOPz Botanical rooftop with fairy lights and hanging greenery, Kankarbagh Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/b1g5efpb_IMG_20251210_165344_530IMG-20251128-WA0077.jpg", alt: "ROOFTOPz fine-dining table setting with terracotta wall art, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/xdpexmsp_IMG_20251210_165344_605IMG-20251128-WA0075.jpg", alt: "ROOFTOPz family restaurant seating in Kankarbagh, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/uqu7te1o_IMG-20251128-WA0078.jpg", alt: "Terrace dining with green ambient lights at ROOFTOPz Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/pzzj7cgc_IMG-20251128-WA0084.jpg", alt: "Botanical rooftop lounge with recycled-tyre planters at ROOFTOPz Patna" },
];

export const HERO_IMAGE =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/lxze7p6q_IMG-20260803-WA0024.jpg";

// Real photographs of the hotel rooms (guest-supplied)
export const ROOM_PHOTOS = {
  kingCream: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/s2vigqg9_inbound4637474752300717557.jpg",
  doubleBlue: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/rmurjusw_inbound5816077658167213308.jpg",
  suiteBath: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/oykctt3f_inbound8070694160858520969.jpg",
  tvWall: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/xftjb1ed_inbound7285857500503725008.jpg",
  bathroom: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/tgltrb0e_inbound5815418800014394954.jpg",
};

export const GALLERY = [
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/b5y9itse_IMG-20260803-WA0032.jpg", alt: "Hotel Virasat Retreat building exterior, opposite Medanta Hospital, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/cic1oewh_IMG-20260803-WA0039.jpg", alt: "Spacious Super Deluxe room with wardrobe at Hotel Virasat Retreat, Patna" },
  { url: ROOM_PHOTOS.kingCream, alt: "Air-conditioned deluxe room with king bed at Hotel Virasat Retreat, Patna" },
  { url: ROOM_PHOTOS.suiteBath, alt: "Executive room with attached bathroom near Medanta Hospital, Patna" },
  { url: ROOM_PHOTOS.doubleBlue, alt: "Comfortable double bed room with AC in Kankarbagh, Patna" },
  { url: ROOM_PHOTOS.tvWall, alt: "Room with smart TV and workspace at Hotel Virasat Retreat" },
  { url: ROOM_PHOTOS.bathroom, alt: "Clean modern bathroom with floral tiles, Hotel Virasat Retreat Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/a26vqrgk_inbound7225720102142227088.jpg", alt: "ROOFTOPz Botanical Restaurant rooftop dining at night, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/hnujtk3q_inbound7620112638566192589.jpg", alt: "Rooftop garden restaurant with fairy lights and greenery in Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/x032veqy_inbound4346814631847830989.jpg", alt: "Heritage-themed rooftop seating at ROOFTOPz, Hotel Virasat Retreat" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/7n2lt09s_IMG-20260803-WA0010.jpg", alt: "Residence Suite private drawing room, Hotel Virasat Retreat Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/lcz9b244_IMG-20260803-WA0009.jpg", alt: "Residence Suite private dining space, apartment-style stay in Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/lxze7p6q_IMG-20260803-WA0024.jpg", alt: "Hotel Virasat Retreat reception and front desk, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/yvjmpg0r_IMG-20260606-WA0021.jpg", alt: "AC Deluxe room with king bed and wood panelling, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/xg0b4il5_IMG-20260614-WA0013.jpg", alt: "Spacious AC Super Deluxe room, Hotel Virasat Retreat Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/iymc3a8y_IMG-20260606-WA0020.jpg", alt: "AC Premium room with premium interiors, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/fpss3tlx_IMG-20260803-WA0042.jpg", alt: "AC Premium room with king bed and green accent wall, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/s86q6ty1_IMG-20260803-WA0043.jpg", alt: "AC Premium room with smart TV and air conditioning, Hotel Virasat Retreat" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/nbovv695_IMG-20260803-WA0040.jpg", alt: "Clean attached bathroom in AC Premium room, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/z8sbw8pj_IMG-20260606-WA0011.jpg", alt: "Hotel room with TV, wardrobe and work desk, Hotel Virasat Retreat Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/uaho80a1_IMG-20260803-WA0016.jpg", alt: "Air-conditioned bedroom at Hotel Virasat Retreat, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/1log117x_IMG-20260803-WA0016.jpg", alt: "Residence Suite lounge with teal sofas, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/kt506zb2_IMG-20260803-WA0013.jpg", alt: "Suite bathroom with modern fittings, Hotel Virasat Retreat" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/4h2e90b6_IMG-20260801-WA0030.webp", alt: "ROOFTOPz rooftop restaurant dining hall, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/7pp2cafj_IMG-20260801-WA0051.jpg", alt: "ROOFTOPz restaurant with terracotta heritage wall art, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/jo46d6qf_inbound7046835165685436012.jpg", alt: "Rooftop restaurant seating at ROOFTOPz, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/sga9n7a4_inbound4155622395421730291.jpg", alt: "Botanical rooftop garden dining area, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/wmfhehjh_IMG-20260803-WA0036.jpg", alt: "Tea Toast Tea Bar & Café interior, Kankarbagh Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/nfhz7w56_IMG-20260803-WA0034.jpg", alt: "Tea Toast & Fire n Fury Firezza café storefront, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/37snnrs3_IMG-20260803-WA0025.jpg", alt: "Banquet decorated for a birthday party, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/x0rhym1e_IMG-20260803-WA0030.jpg", alt: "Banquet stage decor for a 75th birthday celebration, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/gk5pdtse_IMG-20260803-WA0028.jpg", alt: "Banquet hall setup for an anniversary event, Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/pxo7jct3_IMG-20260803-WA0029.jpg", alt: "Guests celebrating at a banquet event, Hotel Virasat Retreat Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/v9cch2r4_IMG-20260815-WA0051.webp", alt: "Independence Day flag hoisting on the rooftop of Hotel Virasat Retreat, opposite Medanta Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/4hzyethx_IMG-20260815-WA0053.webp", alt: "Independence Day celebration on the rooftop at Hotel Virasat Retreat, Kankarbagh Patna" },
];

export const DETAIL_IMAGE = ROOM_PHOTOS.kingCream;

export const ROOFTOP_IMAGES = [
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/4h2e90b6_IMG-20260801-WA0030.webp",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/hnujtk3q_inbound7620112638566192589.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/7pp2cafj_IMG-20260801-WA0051.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/x032veqy_inbound4346814631847830989.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/a26vqrgk_inbound7225720102142227088.jpg",
];

export const BANQUET_IMAGES = [
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/37snnrs3_IMG-20260803-WA0025.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/x0rhym1e_IMG-20260803-WA0030.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/gk5pdtse_IMG-20260803-WA0028.jpg",
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/pxo7jct3_IMG-20260803-WA0029.jpg",
];

export const EVENT_PACKAGES = [
  {
    name: "Birthday Bashes",
    tag: "From kids' themes to milestone birthdays",
    desc: "Custom theme backdrops, balloon & LED decor, marquee name lights, cake table and catering — a picture-perfect celebration your guests will remember.",
    icon: "Cake",
  },
  {
    name: "Anniversaries & Milestones",
    tag: "25th, 50th, 75th & beyond",
    desc: "Elegant floral and drape setups, romantic lighting, custom name lights and a curated menu to honour every special year together.",
    icon: "Heart",
  },
  {
    name: "Weddings & Receptions",
    tag: "Tilak, engagement, reception",
    desc: "Intimate wedding functions with grand stage decor, premium multi-cuisine catering and full-service hospitality on our dedicated banquet floor.",
    icon: "Gem",
  },
  {
    name: "Corporate & Kitty Parties",
    tag: "Meetings, get-togethers, kitty",
    desc: "Flexible seating, projector-ready setup, tea/snack counters and full lunch or dinner spreads for teams, clubs and social groups.",
    icon: "Briefcase",
  },
];

export const BANQUET_INCLUDES = [
  "Custom theme decoration & backdrop",
  "Balloon, floral & LED lighting setup",
  "Marquee name & number lights",
  "In-house catering — veg & non-veg",
  "Cake, flowers & welcome arrangements",
  "Music / DJ setup on request",
  "Dedicated event coordinator",
  "Ample seating & dance floor",
];


export const ROOFTOP_BRANDS = [
  {
    name: "FIREZZA — Fire n Fury",
    tagline: "Indian Tadka Pizzas",
    logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/po6y4w40_IMG-20260803-WA0018.jpg",
    desc: "Hand-tossed pizzas with a bold desi twist — tandoori, tikka and spicy tadka toppings on a crisp, fresh-baked base. Fired up in our rooftop kitchen, est. 2025.",
  },
  {
    name: "Virasat-e-Biryani",
    tagline: "Champaran Style Dum Biryani",
    logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/etddy9tq_IMG-20260223-WA0006.jpg",
    desc: "Slow-cooked, sealed-pot 'handi' biryani in authentic Champaran style — fragrant long-grain rice, tender meat and heirloom Bihari spices, opened fresh at your table.",
  },
];

export const PHOTO_STRIP = [
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/b5y9itse_IMG-20260803-WA0032.jpg", alt: "Hotel Virasat Retreat building exterior opposite Medanta Hospital, Patna", cap: "The Hotel" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/xftjb1ed_inbound7285857500503725008.jpg", alt: "AC Standard room with smart TV and workspace, Hotel Virasat Retreat Patna", cap: "AC Standard" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/yvjmpg0r_IMG-20260606-WA0021.jpg", alt: "AC Deluxe room with king bed and wood panelling, Patna", cap: "AC Deluxe" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/xg0b4il5_IMG-20260614-WA0013.jpg", alt: "Spacious AC Super Deluxe room with marble floor, Hotel Virasat Retreat Patna", cap: "AC Super Deluxe" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/iymc3a8y_IMG-20260606-WA0020.jpg", alt: "AC Premium room with premium interiors at Hotel Virasat Retreat, Patna", cap: "AC Premium" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/7pp2cafj_IMG-20260801-WA0051.jpg", alt: "ROOFTOPz Botanical restaurant with terracotta heritage wall art, Patna", cap: "ROOFTOPz Dining" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/7n2lt09s_IMG-20260803-WA0010.jpg", alt: "Residence Suite private drawing room at Hotel Virasat Retreat, Patna", cap: "The Residence Suite" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/x0rhym1e_IMG-20260803-WA0030.jpg", alt: "Banquet hall decorated for a birthday celebration, Patna", cap: "Banquet & Events" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/a26vqrgk_inbound7225720102142227088.jpg", alt: "Rooftop restaurant evening ambiance at Hotel Virasat Retreat, Patna", cap: "Evenings Above Patna" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/wmfhehjh_IMG-20260803-WA0036.jpg", alt: "Tea Toast Tea Bar & Café cosy interior, Kankarbagh Patna", cap: "Tea Toast Café" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/4h2e90b6_IMG-20260801-WA0030.webp", alt: "ROOFTOPz Botanical rooftop restaurant dining hall, Patna", cap: "Rooftop Restaurant" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/x032veqy_inbound4346814631847830989.jpg", alt: "Heritage-themed rooftop lounge seating at ROOFTOPz, Patna", cap: "Terrace Lounge" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/fpss3tlx_IMG-20260803-WA0042.jpg", alt: "Spacious AC Premium room with king bed at Hotel Virasat Retreat, Patna", cap: "Premium Comfort" },
  { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/lcz9b244_IMG-20260803-WA0009.jpg", alt: "Residence Suite private dining space, Hotel Virasat Retreat Patna", cap: "Suite Dining" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Rooted in Virasat",
    body:
      "Virasat means heritage — a legacy of Bihar's warmth carried into every corner of our 16 boutique rooms. This is Patna hospitality, reimagined for the modern traveller.",
  },
  {
    no: "02",
    title: "Opposite Medanta",
    body:
      "Set directly opposite Medanta Super Speciality Hospital in a quiet residential pocket of Patna, we are the calm, comfortable stay for patients, attendants and families who need to be close by.",
  },
  {
    no: "03",
    title: "A Sky Full of Green",
    body:
      "Dine under the stars at ROOFTOPz Botanical Restaurant, host your celebration in our 3rd-floor banquet, and rest in rooms designed for deep, quiet sleep.",
  },
];

// Room categories & tariff — official Hotel Virasat Retreat tariff plan.
// Plans: EP (room only), CP (+breakfast), MAP (+2 meals), AP (+3 meals). 5% GST extra.
export const ROOMS = [
  {
    id: "ac-standard",
    name: "AC Standard",
    ac: true,
    roomNos: "2, 4, 5, 6",
    count: 4,
    occupancy: "Up to 2 guests",
    beds: "Double Bed",
    plans: { ep: 1999, cp: 2149, map: 2345, ap: 2549 },
    blurb:
      "A cosy air-conditioned room with a comfortable double bed, smart TV and clean modern bathroom — the smart-value choice for a stay in Patna.",
    amenities: ["Air Conditioning", "Free Wi-Fi", "Smart TV", "Attached Bathroom", "Daily Housekeeping"],
    image: ROOM_PHOTOS.tvWall,
  },
  {
    id: "ac-deluxe",
    name: "AC Deluxe",
    ac: true,
    roomNos: "3, 7, 8, 10, 15",
    count: 5,
    occupancy: "Up to 2 guests",
    beds: "King / Double Bed",
    plans: { ep: 2299, cp: 2449, map: 2649, ap: 2849 },
    blurb:
      "More space and a plush king bed with warm wood interiors — ideal for couples and business travellers who want extra comfort near Medanta Hospital.",
    amenities: ["Air Conditioning", "Free Wi-Fi", "Smart TV", "Tea/Coffee Maker", "Room Service"],
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/yvjmpg0r_IMG-20260606-WA0021.jpg",
  },
  {
    id: "ac-super-deluxe",
    name: "AC Super Deluxe",
    ac: true,
    roomNos: "1, 9, 11, 12, 14",
    count: 5,
    occupancy: "Triple occupancy",
    beds: "King Bed + Extra Bed",
    plans: { ep: 2549, cp: 2699, map: 2899, ap: 3099 },
    blurb:
      "Our roomy triple-occupancy category with a spacious layout and attached bathroom — perfect for small families visiting Patna together.",
    amenities: ["Triple Occupancy", "Air Conditioning", "Free Wi-Fi", "Smart TV", "Room Service", "Attached Bathroom"],
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/xg0b4il5_IMG-20260614-WA0013.jpg",
  },
  {
    id: "ac-premium",
    name: "AC Premium",
    ac: true,
    roomNos: "16",
    count: 1,
    occupancy: "Up to 2 guests",
    beds: "Premium King Bed",
    plans: { ep: 2699, cp: 2849, map: 3049, ap: 3199 },
    blurb:
      "Our finest room — the premium retreat with the best fittings and finishes in the hotel. The top luxury hotel room in Kankarbagh, Patna.",
    amenities: ["Premium Interiors", "Air Conditioning", "Free Wi-Fi", "Smart TV", "24x7 Room Service"],
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/fpss3tlx_IMG-20260803-WA0042.jpg",
  },
];

// Premium apartment-style Suite (Airbnb-like) with private drawing room, dining & kitchenette.
export const SUITE = {
  id: "residence-suite",
  name: "The Residence Suite",
  priceFrom: 4500,
  tagline: "Your private apartment in Patna",
  blurb:
    "An Airbnb-style suite with its own drawing room, private dining space and a small kitchen — perfect for families and long stays. Live like a local with all the comfort of a hotel. A two-room set can be booked together for larger groups.",
  features: [
    "Private drawing / living room",
    "Private dining space",
    "Small in-suite kitchen",
    "Spacious AC bedroom + wardrobe",
    "Attached bathroom with hot water",
    "Two-room set available on request",
  ],
  images: [
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/7n2lt09s_IMG-20260803-WA0010.jpg", alt: "Suite private drawing room with sofas at Hotel Virasat Retreat, Patna" },
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/lcz9b244_IMG-20260803-WA0009.jpg", alt: "Suite private dining space and living area, Patna apartment-style stay" },
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/1log117x_IMG-20260803-WA0016.jpg", alt: "Spacious suite drawing room with teal sofas and LED ceiling, Hotel Virasat Retreat Patna" },
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/kt506zb2_IMG-20260803-WA0013.jpg", alt: "Lounge seating in the Residence Suite, Patna" },
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/wtdc8pvs_IMG-20260803-WA0014%281%29.jpg", alt: "Suite attached bathroom with hot water, Hotel Virasat Retreat" },
  ],
};


export const CAFE = {
  name: "Tea Toast",
  sub: "Tea Bar & Café · by Hotel Virasat Retreat",
  hours: "7:00 AM – 10:15 PM",
  priceFor2: "₹200–₹400 for two",
  desc:
    "Kankarbagh's ultimate budget-friendly hangout, right opposite Medanta Hospital. An eclectic mix of rich beverages, fast food and bold Chinese flavours — premium café vibes and generous portions without breaking the bank.",
  signature: "Fire n Fury Firezza — a sizzling, cheese-loaded fusion pizza with a punch of bold heat.",
  highlights: [
    "Tandoori Tea (smoky & authentic)",
    "Veg Grilled Sandwich",
    "Veg Noodles",
    "Veg Manchow Soup",
    "Chicken 65",
    "Garlic Chicken",
  ],
  images: [
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/wmfhehjh_IMG-20260803-WA0036.jpg", alt: "Tea Toast Tea Bar & Café cosy interior seating, Kankarbagh Patna" },
    { url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_patna-heritage-hotel/artifacts/nfhz7w56_IMG-20260803-WA0034.jpg", alt: "Tea Toast & Fire n Fury Firezza café storefront opposite Medanta, Patna" },
  ],
};

export const MEAL_PLANS = [
  { code: "EP", name: "European Plan", desc: "Room only — no meals included." },
  { code: "CP", name: "Continental Plan", desc: "With breakfast. Complimentary for single occupancy; ₹150 extra for double." },
  { code: "MAP", name: "Modified American Plan", desc: "Breakfast + lunch or dinner. Complimentary for single; ₹500 extra for double." },
  { code: "AP", name: "American Plan", desc: "Breakfast + lunch + dinner. Complimentary for single; ₹500 extra for double." },
];

export const TARIFF_NOTES = [
  "Extra bed charges: ₹500 per bed",
  "Power backup through inverter",
  "5% GST applicable extra on all tariffs",
];

export const AMENITIES = [
  { icon: "Wifi", label: "High-Speed Wi-Fi" },
  { icon: "Wind", label: "Air Conditioning" },
  { icon: "UtensilsCrossed", label: "Rooftop Restaurant" },
  { icon: "Car", label: "Free Parking" },
  { icon: "ConciergeBell", label: "24×7 Front Desk" },
  { icon: "Coffee", label: "Room Service" },
  { icon: "Sparkles", label: "Daily Housekeeping" },
  { icon: "ShieldCheck", label: "CCTV Security" },
  { icon: "Building2", label: "Banquet Hall" },
  { icon: "BedDouble", label: "Power Backup" },
];

export const REVIEWS = [
  {
    name: "Ananya Sharma",
    source: "Google",
    rating: 5,
    text:
      "Stayed here while a family member was admitted at Medanta. Spotless rooms, warm staff and the rooftop dinner was a lovely break. Walking distance to the hospital.",
  },
  {
    name: "Rakesh Verma",
    source: "MakeMyTrip",
    rating: 5,
    text:
      "Best value luxury stay in Patna. The Executive Suite was spacious and quiet. ROOFTOPz food is genuinely excellent — try the evening ambiance.",
  },
  {
    name: "Priya Nair",
    source: "Booking.com",
    rating: 4,
    text:
      "Hosted a small reception in the 3rd-floor banquet. The team handled everything beautifully. Would happily recommend to families in Patna.",
  },
];

export const OTAS = ["Google", "MakeMyTrip", "Agoda", "Goibibo", "Booking.com", "Cleartrip"];
export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=Hotel+Virasat+Retreat+Patna+reviews";

export const WHY_DIRECT = [
  { title: "Best Rate, Guaranteed", body: "Book direct and pay less than any OTA — no middle-man commissions passed to you." },
  { title: "Free Room Upgrade", body: "Subject to availability, direct guests get priority on complimentary upgrades." },
  { title: "Flexible Cancellation", body: "Free cancellation up to 24 hours before check-in when you book with us directly." },
  { title: "Early Check-in Priority", body: "Arriving for a hospital appointment? Direct guests get first priority on early check-in." },
];

export const FAQS = [
  {
    q: "How far is Hotel Virasat Retreat from Medanta Super Speciality Hospital, Patna?",
    a: "We are located directly opposite Medanta Hospital in a serene residential area of Patna — a 2-minute walk. It makes us the most convenient hotel near Medanta Patna for patients and attendants.",
  },
  {
    q: "What are the check-in and check-out times?",
    a: "Check-in is from 12:00 PM and check-out is by 11:00 AM. Early check-in and late check-out are available on request, subject to availability.",
  },
  {
    q: "Do the rooms have air conditioning and Wi-Fi?",
    a: "Yes. All our rooms are fully air-conditioned with complimentary high-speed Wi-Fi, a smart TV and daily housekeeping.",
  },
  {
    q: "How can I book a room quickly?",
    a: "The fastest way is to message us on WhatsApp at +91 77650 90955 — tap any 'Book on WhatsApp' button on this page. You can also fill the enquiry form or call us directly.",
  },
  {
    q: "Is there a restaurant in the hotel?",
    a: "Yes — ROOFTOPz Botanical Restaurant on the rooftop serves multi-cuisine vegetarian and non-vegetarian dishes with in-room dining available 24×7.",
  },
  {
    q: "Do you have a good family restaurant in Kankarbagh, Patna?",
    a: "Yes. ROOFTOPz Botanical is a fine-dining, family restaurant in Kankarbagh, Patna — kids and elderly friendly, with soft music, comfortable seating and an open-air rooftop setting. We serve Indian, Chinese and Italian cuisine, both vegetarian and non-vegetarian.",
  },
  {
    q: "Do you have a banquet hall in Kankarbagh, Patna for events?",
    a: "Yes — our 3rd-floor banquet hall in Kankarbagh, Patna is ideal for weddings, receptions, birthday parties, anniversaries, kitty parties and corporate events. We offer fully customised packages with theme decoration and in-house catering (veg & non-veg).",
  },
  {
    q: "What is your cancellation policy?",
    a: "Direct bookings enjoy free cancellation up to 24 hours before check-in. No-show bookings are charged for the first night. The 10% direct-booking offer requires a minimum 2-night stay.",
  },
  {
    q: "How clean are the rooms and what are your housekeeping standards?",
    a: "Cleanliness is our top priority. Every room is deep-cleaned and sanitised before check-in, with fresh linens and towels, daily housekeeping, and regular pest control. Bed sheets and bathrooms are inspected before each guest arrives.",
  },
  {
    q: "Do the ACs work well and how is room climate controlled?",
    a: "All AC rooms have well-maintained, regularly serviced air-conditioners that cool quickly, even in Patna summers. Our maintenance team checks every AC before check-in, and any issue is attended to promptly on request.",
  },
  {
    q: "What in-room amenities and essentials are provided?",
    a: "Each room includes a smart TV, free high-speed Wi-Fi, fresh towels and toiletries, drinking water, tea/coffee on request, a work desk, wardrobe and 24×7 room service. Slippers, extra blankets and toiletries are available on request.",
  },
  {
    q: "How close is the hotel to Medanta Hospital and other medical facilities?",
    a: "We are directly opposite Medanta Super Speciality Hospital — about a 2-minute walk — making us the most convenient stay for patients and attendants. Several clinics, pharmacies and diagnostic centres are also within walking distance in Kankarbagh.",
  },
  {
    q: "Is room service and food available? What about the menu?",
    a: "Yes — in-room dining is available with a multi-cuisine menu (veg and non-veg) from ROOFTOPz Botanical Restaurant, plus beverages, fast food and Chinese from our Tea Toast café. Room service runs through the day; do ask the front desk for the current menu.",
  },
  {
    q: "How do I reach Hotel Virasat Retreat and is parking available?",
    a: "We are on Kankarbagh Main Road, opposite Medanta Hospital — about 6 km from Patna Junction, 7 km from Gandhi Maidan and 9 km from Jayaprakash Narayan Airport. Free on-site parking and 24×7 front desk assistance are available.",
  },
  {
    q: "Is there power backup during electricity cuts?",
    a: "Yes. We provide power backup through an inverter so your essentials keep running during any power cut.",
  },
];

export const NEARBY = [
  { name: "Medanta Super Speciality Hospital", dist: "Opposite · 2 min walk" },
  { name: "Kankarbagh Main Road", dist: "0 km" },
  { name: "Patna Junction Railway Station", dist: "6 km" },
  { name: "Gandhi Maidan", dist: "7 km" },
  { name: "Jayaprakash Narayan Airport", dist: "9 km" },
  { name: "Sanjay Gandhi Biological Park (Zoo)", dist: "8 km" },
];
